import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=746b7134&scoped=true"
import script from "./OptionCard.vue?vue&type=script&lang=js"
export * from "./OptionCard.vue?vue&type=script&lang=js"
import style0 from "./OptionCard.vue?vue&type=style&index=0&id=746b7134&prod&lang=scss&scoped=true"
import style1 from "./OptionCard.vue?vue&type=style&index=1&id=746b7134&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b7134",
  null
  
)

export default component.exports